export default "/build/images/light.png?95654913892f89a39ad5effca833d3e3";